module.exports = __webpack_public_path__ + "img/delivery.d5c9d0b1.svg";